<app-auth-shell [testimonial]="false">
  @if (isSubmitting()) {
    <div
      class="flex flex-col items-center gap-4 py-12 text-center"
      role="status">
      <vx-icon
        name="circle-notch"
        size="lg"
        class="animate-spin text-zinc-400 motion-reduce:animate-none" />
      <p class="text-lg tracking-tight text-zinc-100">
        {{ 'pages.auth.newOrganization.creating.first' | transloco }}
      </p>
      <!-- staggered in, one quip at a time -->
      <p
        class="animate-fade-up text-sm tracking-tight text-zinc-400 opacity-0 animate-delay-1000 animate-duration-500 animate-once animate-ease-in-out motion-reduce:animate-none motion-reduce:opacity-100">
        {{ 'pages.auth.newOrganization.creating.second' | transloco }}
      </p>
      <p
        class="animate-fade-up text-sm tracking-tight text-zinc-400 opacity-0 animate-delay-2250 animate-duration-500 animate-once animate-ease-in-out motion-reduce:animate-none motion-reduce:opacity-100">
        {{ 'pages.auth.newOrganization.creating.third' | transloco }}
      </p>
    </div>
  } @else {
    <app-auth-header
      [title]="'pages.auth.newOrganization.title' | transloco"
      [subtitle]="'pages.auth.newOrganization.subtitle' | transloco" />

    <form [formGroup]="form" (ngSubmit)="create()" novalidate>
      <app-auth-panel>
        <vx-form-field
          [label]="'pages.auth.newOrganization.nameLabel' | transloco">
          <vx-input
            size="lg"
            name="organization"
            formControlName="name"
            autocomplete="organization"
            [placeholder]="
              'pages.auth.newOrganization.namePlaceholder' | transloco
            " />
        </vx-form-field>

        <label
          class="flex items-start gap-3 text-13 leading-5 tracking-tight text-zinc-400">
          <vx-checkbox class="mt-0.5" formControlName="acceptTerms" />
          <span>
            {{ 'pages.auth.newOrganization.terms.before' | transloco }}
            <a
              class="text-zinc-300 underline underline-offset-2 hover:text-zinc-100"
              href="https://incidite.com/legal/terms-and-conditions"
              target="_blank"
              rel="noopener"
              >{{ 'pages.auth.newOrganization.terms.termsLink' | transloco }}</a
            >{{ 'pages.auth.newOrganization.terms.middle' | transloco }}
            <a
              class="text-zinc-300 underline underline-offset-2 hover:text-zinc-100"
              href="https://incidite.com/legal/privacy-policy"
              target="_blank"
              rel="noopener"
              >{{
                'pages.auth.newOrganization.terms.privacyLink' | transloco
              }}</a
            >{{ 'pages.auth.newOrganization.terms.after' | transloco }}
          </span>
        </label>

        @if (failed()) {
          <vx-callout tone="danger">
            {{ 'pages.auth.newOrganization.failed' | transloco }}
          </vx-callout>
        }

        <vx-button
          type="submit"
          size="lg"
          [fullWidth]="true"
          [disabled]="form.invalid">
          {{ 'pages.auth.newOrganization.submit' | transloco }}
        </vx-button>
      </app-auth-panel>
    </form>
  }
</app-auth-shell>
